if (!customElements.get('aizone-header')) customElements.define('aizone-header', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort(); this.controller = new AbortController(); const options={signal:this.controller.signal};
  const disclosures=[...this.querySelectorAll('details')];
  const close=focus=>{const opened=disclosures.find(d=>d.open);disclosures.forEach(d=>d.open=false);if(focus&&opened)opened.querySelector('summary')?.focus();};
  // Keep links visible until the browser completes their native navigation.
  document.addEventListener('click',e=>{if(!this.contains(e.target))close(false);},options);
  this.addEventListener('keydown',e=>{if(e.key==='Escape'&&disclosures.some(d=>d.open)){e.preventDefault();close(true);}},options);
  this.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))close(false);},options);
  disclosures.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)disclosures.filter(x=>x!==d&&!x.contains(d)&&!d.contains(x)).forEach(x=>x.open=false);},options));
 }
 disconnectedCallback(){this.controller?.abort();}
});
